module.exports = "<div class=\"register-buttons\">\r\n    <span><a href=\"signin\" class=\"btn sign-in-link\">Sign In</a></span>\r\n    <a href=\"$RegisterLink\" class=\"btn btn-warning register-cta\">Register</a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/hubspot-register-button.html
// module id = 439
// module chunks = 1